var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleCaretLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 17.2253C18.3416 17.2253 18.1832 17.1669 18.0582 17.0419L12.6249 11.6086C11.7416 10.7253 11.7416 9.27526 12.6249 8.39193L18.0582 2.95859C18.2999 2.71693 18.6999 2.71693 18.9416 2.95859C19.1832 3.20026 19.1832 3.60026 18.9416 3.84193L13.5082 9.27526C13.1082 9.67526 13.1082 10.3253 13.5082 10.7253L18.9416 16.1586C19.1832 16.4003 19.1832 16.8003 18.9416 17.0419C18.8166 17.1586 18.6582 17.2253 18.4999 17.2253Z",
    fill: "#787486"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 17.2253C12.3416 17.2253 12.1832 17.1669 12.0582 17.0419L6.6249 11.6086C5.74157 10.7253 5.74157 9.27526 6.6249 8.39193L12.0582 2.95859C12.2999 2.71693 12.6999 2.71693 12.9416 2.95859C13.1832 3.20026 13.1832 3.60026 12.9416 3.84193L7.50824 9.27526C7.10824 9.67526 7.10824 10.3253 7.50824 10.7253L12.9416 16.1586C13.1832 16.4003 13.1832 16.8003 12.9416 17.0419C12.8166 17.1586 12.6582 17.2253 12.4999 17.2253Z",
    fill: "#787486"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCaretLeft);
export default __webpack_public_path__ + "static/media/DoubleCaretLeft.357e79541833d3fe2b2980a9ed8dfab0.svg";
export { ForwardRef as ReactComponent };